import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";

const REVIEW_CTA = {
  de: "Selbst bewerten",
  en: "Leave a review",
  it: "Lascia una recensione",
  ja: "レビューを書く",
  zh: "撰写评价",
};

export const TestimonialMarquee = () => {
  const [reviews, setReviews] = useState([]);
  const { lang } = useI18n();

  useEffect(() => {
    api.get("/reviews").then((r) => setReviews(r.data || [])).catch(() => {});
  }, []);

  // Nur echte, im Admin freigegebene Bewertungen zeigen — sonst bleibt das Band ausgeblendet
  if (reviews.length === 0) return null;

  return (
    <section className="border-y border-white/5 py-16 bg-[#0A0A0A] marquee-fade" data-testid="testimonial-marquee">
      <Marquee speed={32} gradient={false} pauseOnHover>
        {reviews.map((r) => (
          <figure key={r.id} className="flex flex-col items-center gap-4 mx-12 max-w-lg text-center" data-testid={`review-${r.id}`}>
            <div className="flex gap-1 shrink-0" aria-label={`${r.rating} von 5 Sternen`}>
              {[...Array(5)].map((_, s) => (
                <Star key={s} className={`w-4 h-4 ${s < r.rating ? "fill-gold text-gold" : "text-cream/20"}`} />
              ))}
            </div>
            <blockquote className="font-editorial italic text-cream/90 text-xl md:text-2xl leading-relaxed">
              „{r.text}“
            </blockquote>
            <figcaption className="font-display text-[10px] tracking-[0.3em] text-cream/40 shrink-0">
              — {r.name} · {r.lang?.toUpperCase()}
            </figcaption>
          </figure>
        ))}
      </Marquee>
      <div className="text-center mt-6">
        <Link
          to="/bewertung"
          data-testid="marquee-review-cta"
          className="font-display text-[9px] tracking-[0.35em] text-cream/40 hover:text-gold transition-colors"
        >
          — {(REVIEW_CTA[lang] || REVIEW_CTA.de).toUpperCase()} →
        </Link>
      </div>
    </section>
  );
};
